import React from "react";
import { CreateDrawer } from "../../components/drawer/DrawerComponent";
import { ProductForm } from "../../forms/ProductForm";
import { sAddProduct } from "../../constants/strings";
import { ProductsRegister } from "./ProductsRegister";

export const Products = () => {
  return (
    <div>
      <CreateDrawer title={sAddProduct} form={<ProductForm />} />
      <ProductsRegister />
    </div>
  );
};
